import AppHeader from '../AppHeader'
import DayJs from 'dayjs'

export default {
  name: 'company_notice_detail',
  components: {
    AppHeader
  },
  data: () => ({
    companyNotice: {
      id: '',
      title: '',
      detail: '',
      startDate: '',
      endDate: '',
      isSendMail: ''
    }
  }),
  computed: {
    startDateFormat () {
      return DayJs(this.companyNotice.startDate).format('YYYY年MM月DD日')
    },
    endDateFormat () {
      return DayJs(this.companyNotice.endDate).format('YYYY年MM月DD日')
    },
    isSendMailFormat () {
      return this.companyNotice.isSendMail === 1 ? '配信あり' : '配信なし'
    }
  },
  created () {
    this.getCompanyNotice()
  },
  methods: {
    goBack: function () {
      this.$router.push('/company_notice_list')
    },
    async getCompanyNotice () {
      // 詳細情報取得
      const res = await this.$store.dispatch('GET_COMPANY_NOTICE', {id: this.$route.params.company_notice_id})
      .catch(err => {
        console.error(err)
        return
      })
      this.companyNotice.id = res.company_notices.id
      this.companyNotice.isSendMail = res.company_notices.is_mail_delivery
      this.companyNotice.title = res.company_notices.notice_title
      this.companyNotice.detail = res.company_notices.notice_content
      this.companyNotice.startDate = res.company_notices.notice_start_date
      this.companyNotice.endDate = res.company_notices.notice_end_date
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/company-notice-detail.js